import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { useSnowplowContext } from "supercell-frontend-base/src/analytics/snowplow";

import { NewsView } from "./view";

export const NewsController = () => {
    const { pathname: pagePath } = useLocation();
    const { trackPageView } = useSnowplowContext();

    useEffect(() => {
        trackPageView("News", pagePath);

        window.history.pushState({ home: true }, undefined);
    }, []);

    return <NewsView />;
};
